module.exports = __webpack_public_path__ + "img/s5_stepimg01.a9f02068.png";